import React, { Component } from 'react';
import ReactTable from 'react-table-6';
import { ToastContainer, toast } from "react-toastify";
import $ from 'jquery';
import Loader from 'react-loader-spinner';
import { slide as Menu } from 'react-burger-menu';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import MyAccount from './MyAccount';
import logout from '../../login/Logout';
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import { Doughnut, Pie, Bar } from 'react-chartjs-2';
import ViewCreditUsage from './ViewCreditUsage';

class Invoices extends Component {

    constructor() {
        super();
        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };
        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: false, showTicketStatusPopup: false, hideDialog: false,
                hideLogoutConfirmation: false, showTicketStatusOpenPopup: false,
            });
        };
        this.state = {
            showMyAcountPopUp: false,
            hideLogoutConfirmation: false,
            showTicketStatusOpenPopup: false,
            showTicketStatusPopup: false,
            walletBalance: 0,
            invoices: [],
            invoiceHtml: '',
            displayInvoiceItem: false,
            gstAmt: '',
            unitPrice: '',
            successResp: false,
            displayGeneratePdf: false,
            ticketData: [],
            editedId: '-1',
            ticketTitle: '',
            ticketDescription: '',
            ticketStatus: '',
            ticketType: '',
            ticketPriority: '',
            lastModifiedDate: '',
            ticketFileName: '',
            ticketInfo: [],
            showRaiseTicketPage: false,
            showPreviousRaiseTicket: false,
            selectedFile: null,
            imagePreviewUrl: null,
            checkboxActive: true,
            isViewCreditUsage: false,
            billingSetting: {},
            paymentStatus: null,
            projectName: null,
            billingType: null
        }

        this.ticketStatusButton = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.updateTicketStatusApi(this.state.editedId, this.state.ticketDescription,
                    this.state.ticketPriority, this.state.ticketStatus, this.state.ticketType,
                    this.state.ticketTitle)
            }
        }, {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ hideDeletePopup: false, showTicketStatusOpenPopup: false, showTicketStatusPopup: false });
            }
        }];

        this.logoutButton = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': (props) => {
                logout();
            }
        },
        {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ hideLogoutConfirmation: false });
            }
        }];


        this.statusVar = [];
        this.createdDate = '';
    }

    componentDidMount() {
        var currentUrl = window.location.href;
        if (currentUrl.includes("/platform/invoice")) {
            $("#conversational-ai").addClass('active-dhee-console-link');
        } else if (currentUrl.includes("/platform/cloud-akshar")) {
            $("#cloud-akshar").addClass('active-dhee-console-link');
            /*} else if (currentUrl.includes("/platform/cloud-nlp")) {
                $("#cloud-nlp").addClass('active-dhee-console-link');*/
        } else if (currentUrl.includes("/platform/cloud-asr")) {
            $("#cloud-asr").addClass('active-dhee-console-link');
        } else if (currentUrl.includes("/platform/cloud-tts")) {
            $("#cloud-tts").addClass('active-dhee-console-link');
        }

        /* var helpWidgetScript = document.getElementById("helpWidgetScript");
         if (!helpWidgetScript) {
             var script = document.createElement("script");
             script.setAttribute("id", "helpWidgetScript");
             script.async = true;
             script.src = "/platform/js/help-widget.js";
             document.body.appendChild(script);
         }*/
        setTimeout(() => {
            this.fetchInvoicesApi();
            this.fetchProjectBillingSetting();
            this.fetchWalletBalanceApi();
            this.fetchBillingTypeApi();
        }, 300);
        document.addEventListener("keydown", this.escFunction, false);
    }

    escFunction = (event) => {
        if (event.keyCode === 27) {
            if (this.state.showPreviousTicketPage === true) {
                this.setState({ showPreviousTicketPage: false });
            }
            if (this.state.showRaiseTicketPage === true) {
                this.setState({ showRaiseTicketPage: false, showPreviousTicketPage: true });
            }
            if (this.state.showMyAcountPopUp) {
                this.setState({ showMyAcountPopUp: false })
            }
        }
    }

    fetchInvoicesApi = () => {
        var thisController = this;
        thisController.state.invoices = [];
        thisController.state.successResp = false;
        $.ajax({
            url: "/api/get-invoice-reciept",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId")
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                thisController.state.successResp = true;
                if (res.success === true) {
                    if (res.result.pending.length > 0) {
                        thisController.state.invoices = res.result.pending;
                        thisController.state.invoiceHtml = res.result.pending[0];
                        thisController.state.paymentStatus = res.result.pending[0].paymentStatus;
                        thisController.state.displayInvoiceItem = true;
                        thisController.state.displayGeneratePdf = true;
                    }
                    if (res.result.paid.length > 0) {
                        thisController.state.displayGeneratePdf = true;
                        thisController.state.displayInvoiceItem = true;
                        for (var i = 0; i < res.result.paid.length; i++) {
                            thisController.state.invoices.push(res.result.paid[i]);
                        }
                        thisController.state.gstAmt = res.result.paid[0].gstAmount;
                        thisController.state.paymentStatus = thisController.state.invoices[0].paymentStatus;
                        thisController.state.invoiceHtml = thisController.state.invoices[0];
                        thisController.setState(thisController.state);
                    }
                    var doc = document.getElementById('invoice_iframe').contentWindow.document;
                    doc.open();
                    doc.write(thisController.state.invoiceHtml.invoiceHtml);
                    doc.close();
                } else {
                    thisController.state.displayGeneratePdf = false;
                    thisController.state.displayInvoiceItem = false;
                    thisController.state.invoices = [];
                    thisController.setState(thisController.state);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }



    fetchInvoiceTemplate = (props) => {
        var doc = document.getElementById('invoice_iframe').contentWindow.document;
        doc.open();
        doc.write(props.original.invoiceHtml);
        doc.close();
        this.state.invoiceHtml = props.original;
        this.state.isViewCreditUsage = false;
        this.state.displayGeneratePdf = true;
        this.setState(this.state);
    }

    removeDownloadFromIframe = (e) => {
        var invoiceController = this;
        invoiceController.state.successResp = false;

        if (e.target.contentWindow.document.getElementsByClassName("cta-toolbar")[0] != undefined) {
            e.target.contentWindow.document.getElementsByClassName("cta-toolbar")[0].remove();

            var tableHeader = e.target.contentWindow.document.getElementsByClassName('inv__itemtable')[0].rows[0];
            var gstHeader = tableHeader.insertCell(1);
            gstHeader.outerHTML = '<th>GST</th>';
            var unitPriceHeader = tableHeader.insertCell(2);
            unitPriceHeader.outerHTML = '<th>UNIT PRICE</th>';

            var tableCell = e.target.contentWindow.document.getElementsByClassName('inv__itemtable')[0].rows[1];
            var gstCell = tableCell.insertCell(1);
            gstCell.innerHTML = '<td><span class="amount">₹ ' + invoiceController.state.gstAmt + '</span></td>'

            var unitPrice = e.target.contentWindow.document.getElementsByClassName('lineItem__amount rate text-right')[0].innerText.replace(/\D/g, "");
            var netUnitPrice = unitPrice / 100 - invoiceController.state.gstAmt;
            var unitPriceCell = tableCell.insertCell(2);
            unitPriceCell.innerHTML = '<td><span class="amount">₹ ' + netUnitPrice.toFixed(2) + '</span></td>'

            var netUnitPriceElement = e.target.contentWindow.document.getElementsByClassName('lineItem__amount')[0];
            netUnitPriceElement.innerText = "NET UNIT PRICE";
        }
        invoiceController.state.successResp = true;
        invoiceController.setState(invoiceController.state);
    }

    routeToHelpPage = () => {
        $("#read-doc").addClass('active-dhee-console-link');
        $("#raise-ticket").removeClass('active-dhee-console-link');
        window.open("https://readme.dhee.ai/", "_blank")
    }

    showPreviousRaiseTicket = () => {
        $("#raise-ticket").addClass('active-dhee-console-link');
        $("#read-doc").removeClass('active-dhee-console-link');
        this.fetchTicketStatus();
        this.fetchTicketTypeApi();
        this.fetchTicketPriorityApi();
        this.fetchTicketDataApi();
        this.setState({ showPreviousTicketPage: true });
    }

    /*Raise Ticket Fuctionalities*/
    fetchTicketStatus() {
        var thisController = this;
        $.ajax({
            url: "/api/ticket-status",
            async: false,
            method: 'GET',
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    var ticketStatus = res.result;
                    var ele3 = document.getElementById('Ticket-status');
                    if (ele3 != null) {
                        ele3.innerHTML = null;
                        for (var i = 0; i < ticketStatus.length; i++) {
                            ele3.innerHTML = ele3.innerHTML + '<option value="' + ticketStatus[i]['key'] + '">' + ticketStatus[i]['value'] + '</option>';
                            thisController.statusVar = ticketStatus[i]['key'];

                        }
                    }
                } else if (res.success === false && res.result.includes("null")) {
                    thisController.notifyError();
                } else {
                    thisController.notifyFailedToCreate(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    notifyError() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred. Please try again</b>, {
            position: "top-center",
            color: "red"

        });
    }

    notifyFailedToCreate(falseRes) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{falseRes}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    fetchTicketTypeApi() {
        var ticketController = this;
        $.ajax({
            url: "/api/ticket-types",
            async: false,
            method: 'GET',
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    var ticketTypes = res.result;
                    var ele3 = document.getElementById('Ticket-type');
                    if (ele3 != null) {
                        ele3.innerHTML = null;
                        for (var i = 0; i < ticketTypes.length; i++) {
                            ele3.innerHTML = ele3.innerHTML + '<option value="' + ticketTypes[i]['key'] + '">' + ticketTypes[i]['value'] + '</option>';

                        }
                    }
                } else if (res.success === false && res.result.includes("null")) {
                    ticketController.notifyError();

                } else {
                    ticketController.notifyFailedToCreate(res.result);
                }
            },
            error: function (xhr, status, error) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }
    fetchTicketPriorityApi() {
        var thisController = this;
        $.ajax({
            url: "/api/ticket-priority",
            async: false,
            method: 'GET',
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    var ticketPriority = res.result;
                    var ele3 = document.getElementById('Ticket-priority');
                    if (ele3 != null) {
                        ele3.innerHTML = null;
                        for (var i = 0; i < ticketPriority.length; i++) {
                            ele3.innerHTML = ele3.innerHTML + '<option value="' + ticketPriority[i]['key'] + '">' + ticketPriority[i]['value'] + '</option>';

                        }
                    }
                } else if (res.success === false && res.result.includes("null")) {
                    thisController.notifyError();

                } else {
                    thisController.notifyFailedToCreate(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    fetchTicketDataApi() {
        var thisController = this;
        $.ajax({
            url: "/api/generate-ticket",
            async: false,
            method: 'GET',
            data: {
                "userId": JSON.parse(localStorage.getItem("user_details"))["userId"],
                "projectId": localStorage.getItem("currentProjectId"), "showClosed": document.getElementById("Ticket-status-drop-down").value
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true && res.result.length !== 0) {
                    var ticketInfo = res.result;
                    var fullPath = res.result[0].ticketFileName;
                    var filename = fullPath.replace(/^.*[\\\/]/, '');
                    var date = new Date(res.result[res.result.length - 1].lastModifiedDate);
                    var date1 = new Date(res.result[0].createdDate);
                    thisController.setState({
                        ticketData: res.result,
                        editedId: res.result[0].id, ticketTitle: res.result[0].title,
                        ticketDescription: res.result[0].description,
                        ticketStatus: res.result[0].ticketStatus,
                        ticketType: res.result[0].ticketType,
                        ticketPriority: res.result[0].ticketPriority,
                        lastModifiedDate: date.toLocaleString(),
                        ticketFileName: filename

                    });

                    thisController.createdDate = date1.toLocaleString();
                    thisController.fetchCommentsApi(res.result[0].id);

                } else if (res.success === true && res.result.length == 0) {
                    thisController.setState({
                        ticketData: [{
                            title: '',
                            description: '',
                            ticketStatus: '',
                            ticketPriority: '',
                            ticketType: '',
                            id: ''

                        }],
                        ticketInfo: [{
                            ticketId: '',
                            commentedByUserId: '',
                            commentedByUserName: '',
                            commentedByUserEmail: '',
                            comment: '',
                            commentType: '',
                            commentTime: '',

                        }],
                        editedId: '-1', ticketTitle: '',
                        ticketDescription: '',
                        ticketStatus: '',
                        ticketType: '',
                        ticketPriority: '',
                        lastModifiedDate: '',
                        ticketFileName: ''


                    });
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    fetchCommentsApi(ticketCommentId) {
        var thisController = this;

        $.ajax({
            url: "/api/ticket-comments",
            async: false,
            method: 'GET',
            data: {
                "userId": JSON.parse(localStorage.getItem("user_details"))["userId"],
                "projectId": localStorage.getItem("currentProjectId"), ticketId: ticketCommentId
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    console.clear();

                    for (var i = 0; i < res.result.length; i++) {
                        if (res.result[i]['commentTime'] == 0) {
                            res.result[i]['commentTime'] = thisController.createdDate;
                        } else if (res.result[i]['commentTime'] != '0' && res.result[i]['commentTime'] != null) {
                            var date = new Date(res.result[i]['commentTime']);
                            res.result[i]['commentTime'] = date.toLocaleString();
                        }
                    }

                    thisController.setState({ ticketInfo: res.result });

                } else if (res.success === false && res.result.includes("null")) {
                    thisController.notifyError();

                } else {
                    thisController.notifyFailedToCreate(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    closeRaiseTicketPage = () => {
        this.fetchTicketDataApi();
        this.setState({ showRaiseTicketPage: false, showPreviousTicketPage: true });
    }

    showRaiseTicket = () => {
        this.setState({ showPreviousTicketPage: false, showRaiseTicketPage: true });
    }

    closePreviousTicketPage = () => {
        this.setState({ showPreviousTicketPage: false });
    }
    validateTicketFields(title, description) {
        if (title == "" || description == "") {
            this.notifyEmptyFields();
            return false;
        } else {
            return true;
        }

    }

    submitApi = () => {
        var ticketController = this;
        var imagePath = document.getElementById("inputFile1").value;
        var imagetype = imagePath.split('.')[1];
        var imageUrl = this.state.imagePreviewUrl;
        var imagePath = document.getElementById("inputFile1").value;
        var imagetype = imagePath.split('.')[1];
        var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.svg)$/i;
        var title = document.getElementById("title").value;
        var description = document.getElementById("description").value;
        var validateResult = this.validateTicketFields(title, description);
        if (validateResult) {
            var ticketData = {
                projectId: localStorage.getItem("currentProjectId"),
                title: document.getElementById("title").value,
                description: document.getElementById("description").value,
                ticketStatus: document.getElementById("Ticket-status").value,
                ticketPriority: document.getElementById("Ticket-priority").value,
                ticketType: document.getElementById("Ticket-type").value,
                ticketFileName: imagePath,
                ticketFileType: imagetype,
                ticketImageFile: btoa(imageUrl),

            }
            $.ajax({
                url: "/api/generate-ticket",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(ticketData),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        ticketController.notifySuccess(ticketData.title + " generated successfully");

                        ticketController.fetchTicketDataApi();
                        ticketController.setState({ showRaiseTicketPage: false, showPreviousTicketPage: true });
                        document.getElementById("title").value = "";
                        document.getElementById("description").value = "";
                        document.getElementById("inputFile1").value = "";
                    } else if (res.success === false && res.result.includes("null")) {
                        ticketController.notifyError();

                    } else {
                        ticketController.notifyFailedToCreate(res.result);


                    }

                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }

            })
        }
    }

    notifySuccess(Projectkey) {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;{Projectkey}</b>, {
            position: "top-center"
        });
    }

    notifyEmptyFields() {
        toast.dismiss();
        toast(<b>Please fill all fields</b>, {
            position: "top-center",


        });
    }

    updateTicketStatusApi = (ticketid, description,
        ticketPriority, ticketStatus, ticketType, title) => {
        var ticketStatusController = this;
        var statusChanged = (ticketStatus === "OPEN") ? "CLOSED" : "OPEN";
        var updatedData = {
            "userId": JSON.parse(localStorage.getItem("user_details"))["userId"],
            "projectId": localStorage.getItem("currentProjectId"),
            description: description,
            id: ticketid,
            ticketPriority: ticketPriority,
            ticketStatus: statusChanged,
            ticketType: ticketType,
            title: title,
        }

        $.ajax({
            url: "/api/generate-ticket",
            async: false,
            method: 'PATCH',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(updatedData),
            processData: false,
            contentType: "application/json; charset=UTF-8",
            success: function (res) {
                if (res.success === true) {
                    ticketStatusController.setState({ showTicketStatusOpenPopup: false, showTicketStatusPopup: false });
                    ticketStatusController.notifySuccess("Ticket status Updated Successfully");
                    ticketStatusController.fetchTicketDataApi();

                } else if (res.success === false && res.result.includes("null")) {
                    ticketStatusController.notifyError();

                } else {
                    ticketStatusController.notifyFailedToCreate(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        })

    }

    ticketimagePreviewDataUrl(event) {

        let reader = new FileReader();

        reader.onloadend = () => {
            this.setState({
                dataUrl: reader.result
            });

        }
        reader.readAsDataURL(event.target.files[0])
    }

    ticketfileChangedHandler = event => {
        this.ticketimagePreviewDataUrl(event);

        var imagePath = document.getElementById("inputFile1").value;
        const fi = document.getElementById('inputFile1');
        var imagetype = imagePath.split('.')[1];
        var allowedExtensions = /(\.jpg\.png)$/i;
        /* Check if any file is selected */
        if (fi.files.length > 0) {
            for (var i = 0; i <= fi.files.length - 1; i++) {

                const fsize = fi.files.item(i).size;
                const file = Math.round((fsize / 1024));
                if (file >= 4096) {
                }
            }

            this.setState({
                selectedFile: event.target.files[0]
            })

            let reader = new FileReader();

            reader.onloadend = () => {
                this.setState({
                    imagePreviewUrl: reader.result
                });
            }
            reader.readAsBinaryString(event.target.files[0]);
        }
    }

    showMyAcount = () => {
        this.setState({ showMyAcountPopUp: true });
    }

    closeMyAccountPage = () => {
        this.setState({ showMyAcountPopUp: false });
    }

    routeToInvoicePage = () => {
        this.props.history.push('/invoice');
    }

    moveToConversationalAI = () => {
        window.location.href = window.origin + "/platform/projectmgmt";
    }
    moveToAksharPlatform = () => {
        window.location.href = window.origin + "/platform/cloud-akshar";
    }
    moveToNLPPlatform = () => {
        window.location.href = window.origin + "/platform/cloud-nlp";
    }
    moveToSpeechPlatform = () => {
        window.location.href = window.origin + "/platform/cloud-asr";
    }
    moveToTtsPlatform = () => {
        window.location.href = window.origin + "/platform/cloud-tts";
    }

    statushandlechange = (event) => {
        this.fetchTicketDataApi();
    }

    editTicketCell(props, e) {
        var fullPath = props.original.ticketFileName;
        var filename = fullPath.replace(/^.*[\\\/]/, '');
        var date = new Date(props.original.lastModifiedDate);
        this.setState({
            editedId: props.original.id, ticketTitle: props.original.title,
            ticketDescription: props.original.description,
            ticketStatus: props.original.ticketStatus,
            ticketType: props.original.ticketType,
            ticketPriority: props.original.ticketPriority,
            lastModifiedDate: date.toLocaleString(),
            ticketFileName: filename,
        });
        this.fetchCommentsApi(props.original.id);
    }

    saveTicketCell(props, e) {

    }

    showStatusClosePopup = () => {
        if (this.state.ticketStatus == "OPEN") {
            this.setState({ showTicketStatusPopup: true });
        } else {
            this.setState({ showTicketStatusOpenPopup: true })
        }

    }

    notifyEmptyCommentField() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Please enter your comment before submitting</b>, {
            position: "top-center",
        });
    }

    saveTicketCommentsApi = () => {
        var thisController = this;
        if (document.getElementById("comment").value.trim() == "") {
            thisController.notifyEmptyCommentField();
        } else {
            var ticketCommentData = {
                commentedByUserId: JSON.parse(localStorage.getItem("user_details"))["userId"],
                comment: document.getElementById("comment").value.trim(),
                ticketId: thisController.state.editedId,
                projectId: localStorage.getItem("currentProjectId"),

            };

            $.ajax({
                url: "/api/ticket-comments",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(ticketCommentData),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        thisController.notifySuccess("Comment added successfully");
                        thisController.fetchCommentsApi(ticketCommentData.ticketId);

                        document.getElementById("comment").value = "";


                    } else if (res.success === false && res.result.includes("null")) {
                        thisController.notifyError();

                    } else {
                        thisController.notifyFailedToCreate(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            });
        }
    }

    startHelpChat = () => {
        console.log("Starting help chat");
        if (!window.DheeWidgetChat.started) {
            window.DheeWidgetChat.launch();
            $("#helpChatWidgetDiv").animate({ "height": "378" }, 200, function () {
                $("#helpChatWidgetDiv").css('cursor', 'default');
            });
        }

    }

    takeInput = () => {
        $("#helpChatQueryBox").html('').attr('contentEditable', true).focus();
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.escFunction, false);
    }

    handleCheck = (e) => {
        if (e.target.checked) {
            this.setState({ checkboxActive: true });
            window.DheeWidgetChat.autoSend = true;
        } else {
            this.setState({ checkboxActive: false });
            window.DheeWidgetChat.autoSend = false;
        }
    }

    fetchWalletBalanceApi() {
        var invoiceController = this;
        $.ajax({
            url: "/api/get-wallet-amount",
            async: false,
            method: 'GET',
            data: { "projectId": localStorage.getItem("currentProjectId") },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    invoiceController.state.projectName = res.result.name;
                    invoiceController.state.walletBalance = res.result.walletBalance;
                    invoiceController.state.walletBalance = Number(invoiceController.state.walletBalance).toFixed(2);
                    invoiceController.setState(invoiceController);
                } else {
                    invoiceController.state.walletBalance = 0;
                    invoiceController.setState(invoiceController);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    handleViewCreditUsage = () => {
        var invoiceController = this;
        invoiceController.state.isViewCreditUsage = true;
        invoiceController.state.displayGeneratePdf = false;
        invoiceController.setState(invoiceController.state);
        invoiceController.refs.child.getDailyCreditsUsage();
    }

    refreshInvoice = () => {
        this.fetchInvoicesApi();
        this.fetchProjectBillingSetting();
    }

    fetchBillingTypeApi = () => {
        var thisController = this;
        $.ajax({
            url: "/api/project-billing-type",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId")
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    thisController.state.billingType = res.result.billingType;
                    thisController.setState(thisController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    fetchProjectBillingSetting = () => {
        let data = { projectId: localStorage.getItem("currentProjectId") }
        let statusComponent = this;
        $.ajax({
            url: "/api/project-billing-setting",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            data: data,
            success: function (res) {
                if (res.success === true) {
                    statusComponent.state.billingSetting = res.result.projectBillingSettings;
                    statusComponent.state.billingSetting["stateName"] = res.result.stateName;
                    statusComponent.setState(statusComponent.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }


    downloadInvoice = () => {
        window.location.href = "/api/invoice-download?invoiceReceiptId=" + this.state.invoiceHtml.id;
    }

    addMakePaymentButton = (e) => {
        var invoiceController = this;
        if (e.target.contentWindow.document.getElementById("make-payment") != undefined) {
            var makePaymentDiv = e.target.contentWindow.document.getElementById("make-payment");
            if (invoiceController.state.invoiceHtml != undefined && invoiceController.state.invoiceHtml.paymentStatus == "PENDING") {
                var payBtn = document.createElement('button');;
                payBtn.className = "btn";
                payBtn.classList.add("action-button");
                payBtn.style.marginTop = "-50px";
                payBtn.innerText = "Make Payment"
                payBtn.onclick = function () {
                    invoiceController.makePayment();
                };
                makePaymentDiv.appendChild(payBtn);
            }
        }
    }

    makePayment = () => {
        var invoiceController = this;
        window.open(invoiceController.state.invoiceHtml.paymentLinkUrl, '_blank')
    }

    render() {
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!this.state.successResp}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center', marginTop: window.innerHeight / 6 + "px" }}
                />
                <div style={{ display: this.state.successResp ? 'block' : 'none' }}>

                    <div className="wrapper" id="wrap">

                        {/*links for css files used for popup */}
                        <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                        <link href="assets/css/ej2-base.css" rel="stylesheet" />
                        <link href="assets/images/edit.svg" rel="stylesheet" />
                        <link href="assets/images/add.svg" rel="stylesheet" />
                        <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                        <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                        <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                        <link href="assets/css/screenResolution.css" rel="stylesheet" />
                        <link href="assets/css/menu-drop-down.css" rel="stylesheet" />
                        <link href="StyleSheet.css" rel="stylesheet" type="text/css" media="only screen" />
                        <link href="MobileStyleSheet.css" rel="stylesheet" type="text/css" media="only screen and (max-device-width: 480px) , only screen and (-webkit-min-device-pixel-ratio: 2) , screen and (-webkit-device-pixel-ratio:1.5)" />
                        <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                        <link rel="stylesheet" type="text/css" href="//netdna.bootstrapcdn.com/bootstrap/3.1.1/css/bootstrap.min.css" />
                        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                        <link href="assets/css/menu-items.css" rel="stylesheet" />
                        <link href="assets/css/horizantal-line.css" rel="stylesheet" />
                        {/* Theme style */}
                        <link rel="stylesheet" href="assets/css/adminlte.css" />
                        <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                        <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                        <link rel="stylesheet" href="assets/css/drop-down-alignment.css" />
                        <link rel="stylesheet" href="plugins/select2/css/select2.min.css" />
                        {/*links from create new project */}
                        <link rel="stylesheet" href="assets/css/select2.min.css" />
                        <link rel="stylesheet" href="assets/css/flaticon.css" />
                        <link rel="stylesheet" href="assets/css/index.css" />
                        <link rel="stylesheet" href="assets/css/modal-style.css" />
                        <link href="assets/css/material.css" rel="stylesheet" />
                        <link href="assets/css/bootstrap.min.css" rel="stylesheet" />
                        <link href="react-table-without-pagination.css" rel="stylesheet" />
                        <link href="assets/css/div-as-input-field.css" rel="stylesheet" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <link rel="stylesheet" href="assets/css/styles.css" />

                        {/* Navigation bar */}
                        <nav className="main-header navbar navbar-expand bg-white navbar-light border-bottom" id="nav" style={{ height: "75px", marginBottom: '0px' }}>

                            <img src="assets/images/dhee.png" style={{ height: "90px", width: "250px", marginRight: "0px" }} alt="AdminLTE Logo" className="brand-link" />
                            <ul className="navbar-nav ml-auto">
                                <li className="nav-item dropdown col-sm-2">
                                    <div class="dropdown">
                                        <span><img src="assets/images/help.svg" style={{ height: "20px", width: "20px", marginTop: '22px' }} /></span>
                                        <div class="dropdown-content">
                                            <a onClick={this.routeToHelpPage}>&nbsp;&nbsp;Documentation</a>
                                            <a onClick={this.showPreviousRaiseTicket} >&nbsp;Report an issue</a>

                                        </div>
                                    </div></li>
                                <li className="nav-item dropdown col-sm-2">
                                    <span><img title="My account" style={{ height: "20px", width: "20px", marginTop: '22px' }} src="assets/images/account.svg" /></span>
                                    <div class="dropdown-content" >
                                        <a onClick={this.showMyAcount}>&nbsp;My account</a>
                                        <a onClick={this.routeToInvoicePage}>&nbsp;Invoices</a>

                                    </div>
                                </li>
                                {/* Notifications Dropdown Menu */}
                                <li className="nav-item col-sm-2">
                                    <span><img title="Logout" onClick={() => this.setState({ hideLogoutConfirmation: true })} style={{ height: "40px", width: "40px", marginTop: '22px' }} src="./assets/images/power.svg" /></span>
                                </li>

                                <div id="outer-container" className="col-sm-2" style={{ marginTop: "22px", marginRight: "20%" }} >
                                    <Menu pageWrapId={"page-wrap"} outerContainerId="bubble" noOverlay right>
                                        <a style={{ textDecoration: 'none' }} id="conversational-ai" className="menu-item dhee-console-links" onClick={this.moveToConversationalAI}>Conversational AI Platform</a><br />
                                        {/* <a id="cloud-nlp" className="menu-item dhee-console-links" onClick={this.moveToNLPPlatform}>Natural Language Parsers APIs</a><br />*/}
                                        <a id="cloud-asr" className="menu-item dhee-console-links" onClick={this.moveToSpeechPlatform}>Automatic Speech Recognition APIs</a><br />
                                        <a id="cloud-akshar" className="menu-item dhee-console-links" onClick={this.moveToAksharPlatform}>Text Transliteration APIs</a><br />
                                        <a id="cloud-tts" className="menu-item dhee-console-links" onClick={this.moveToTtsPlatform}>Text To Speech APIs</a><br />
                                        {/* <a style={{ textDecoration: 'none' }} id="read-doc" className="menu-item dhee-console-links" onClick={this.routeToHelpPage}>Documentation</a><br />
            <a id="raise-ticket" className="menu-item dhee-console-links" onClick={this.showPreviousRaiseTicket}>Report an issue</a><br /> */}

                                        {/* <div style={{
                                            border: "1px solid",
                                            borderRadius: "10px",
                                            color: "#ffffff",
                                            marginTop: '60px',
                                            textAlign: "center",
                                            padding: "5px",
                                            overflow: "hidden",
                                            height: "81px",
                                            cursor: "pointer",
                                            transition: "all 200ms ease-in-out"
                                        }}
                                            onClick={() => this.startHelpChat()}
                                            id="helpChatWidgetDiv">
                                            <h4>Ask Dhee !</h4>
                                            <p>Try posting your queries here</p>
                                            <img src="./assets/images/microphone-light-ash.png"
                                                style={{ height: "24px", width: "24px", marginTop: "10px" }}
                                                id="dhee_mic_muted_icon" />
                                            <img src="./assets/images/microphone-red-color.png"
                                                style={{ height: "24px", width: "24px", marginTop: "10px", display: "none" }}
                                                id="dhee_mic_recording_icon" />

                                            <img src="./assets/images/speaker-32.png"
                                                style={{ height: "24px", width: "24px", marginTop: "10px", marginLeft: "81px" }}
                                                id="dhee_speaker_active_icon" />
                                            <img src="./assets/images/mute-2-32.png"
                                                style={{ height: "24px", width: "24px", marginTop: "10px", marginLeft: "81px", display: "none" }}
                                                id="dhee_speaker_mute_icon" />

                                            <div align="center" style={{
                                                height: "24px",
                                                marginTop: '5px',
                                                verticalAlign: "center"
                                            }}>
                                                <canvas id="dhee_audio_display_canvas" style={{
                                                    height: "20px",
                                                    marginLeft: "5px",
                                                    width: "80px",
                                                    border: "1px grey solid",
                                                    borderRadius: "5px",
                                                    marginRight: "30px",
                                                    marginTop: "5px"
                                                }}>
                                                </canvas>
                                                <span style={{
                                                    position: "relative",
                                                    top: "-6px"
                                                }}>Auto send </span>
                                                <input type="checkbox" id="autoSendCheckBox" defaultChecked={this.state.checkboxActive} onChange={this.handleCheck} style={{
                                                    position: "relative",
                                                    top: "-5px"
                                                }} />
                                            </div>
                                            <span style={{ fontSize: "0.86em", marginTop: "12px", display: "inline-block" }}>Double click the panel below to type</span>
                                            <div contentEditable={true}
                                                style={{
                                                    border: "1px solid rgb(147, 210, 250)",
                                                    color: "white",
                                                    padding: "5px",
                                                    width: "95%",
                                                    height: "180px",
                                                    margin: "2.5%",
                                                    marginTop: "10px",
                                                    position: "relative",
                                                    borderRadius: "9px",
                                                    overflowY: "auto"

                                                }} id="helpChatQueryBox" onDoubleClick={() => this.takeInput()} >

                                            </div>
                                            <img src="./assets/images/spinner.gif"
                                                style={{ height: "60px", width: "60px", marginTop: "-209px", display: "inline" }}
                                                id="workingSpinner" />
                                            <button type="button" className="btn navyblue-btn"
                                                style={{
                                                    display: this.state.checkboxActive ? "none" : "block", width: "25%",
                                                    marginLeft: "40%",
                                                    color: "#000000", marginBottom: "5px"
                                                }} >Send</button>
                                        </div> */}
                                    </Menu>
                                </div>

                            </ul>
                        </nav>
                        {/* end of navigation bar */}


                        <div className="content-header" >
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-5" style={{ marginLeft: '40px' }}>
                                        <h1 className="m-0 page-title">Invoices</h1>
                                        <h6 className="taglineTxt">View Your Invoices</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="border-bottom" style={{ marginLeft: '60px', marginRight: '60px' }}></div>
                        <ToastContainer className="Toast-at-center" />
                        {/* button */}
                        <div className="row" style={{ marginTop: '5px' }}>
                            <h5 className="nav-item" style={{
                                color: '#282a65',
                                marginTop: '10px', marginLeft: '70px', fontWeight: '900'
                            }}>
                                Invoices for {localStorage.getItem("currentProjectName")}
                            </h5>
                        </div>
                        <div className="row" style={{ marginBottom: '5px' }}>
                            <div className="col-sm-8">
                                <button type="button" className="btn btn-primary navyblue-btn" style={{ marginLeft: '65px', marginTop: '20px' }} onClick={() => window.location.href = '/platform/projectmgmt'}>
                                    <span className="delereuserbtn">Cancel</span></button>
                            </div>

                            <div className="col-sm-4">
                                <div className="d-flex flex-row-reverse pt-2">
                                    <div className="p-2" style={{ display: 'flex', marginRight: '50px' }}>
                                        <button className="btn navyblue-btn"
                                            style={{
                                                height: "auto", width: "auto",
                                                paddingTop: '10px',
                                                display: this.state.displayGeneratePdf ? 'flex' : 'none'
                                            }}
                                            onClick={this.downloadInvoice}>Generate Pdf</button>
                                        <button className="btn action-button"
                                            style={{
                                                display: 'flex',
                                                paddingTop: '10px',
                                            }}
                                            onClick={this.handleViewCreditUsage}>
                                            View Credit Usage
                                        </button>
                                        <button className="btn action-button" title="Refresh project data"
                                            onClick={this.refreshInvoice}>
                                            <img src="./assets/images/refresh_white_24dp.png" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid" style={{ height: 'auto' }}>
                            <link href="assets/css/div-as-input-field.css" rel="stylesheet" />
                            <ToastContainer className="Toast-at-center" />
                            <div className="col-sm-12" style={{ backgroundColor: '#F9F9FB' }}>
                                <div className="row" style={{ paddingLeft: '5px', paddingRight: '30px' }}>
                                    <div className="col-lg-3" style={{ flexBasis: "28%", maxWidth: "28%" }}>
                                        <div className="primeclr" style={{ marginLeft: "30px", minHeight: "120px", borderRadius: "8px", border: "1px solid #282a65" }}>
                                            <div className="pric_head" align="center">

                                                <h5 className="planTitle starter1" style={{ color: "#282a65" }}> Project Credits <br /> <br /><b style={{ color: "#008000" }}><i class="fa fa-inr"></i>&nbsp;{this.state.walletBalance}</b></h5>

                                            </div>
                                        </div>
                                        <br />
                                        <div style={{ marginLeft: '30px' }}>
                                            <ReactTable id='reactTable'
                                                noDataText="Invoice Receipts will be created when you recharge your project wallet balance"
                                                data={this.state.invoices}
                                                columns={[
                                                    {
                                                        Header: <b>All invoices</b>,
                                                        accessor: 'paymentId',
                                                        minWidth: 17,
                                                        overflow: "visible",
                                                        sortable: false,
                                                        Cell: props => (

                                                            <div align="left" className="cursor-change"
                                                                onClick={() => this.fetchInvoiceTemplate(props)}
                                                            >Invoice of {new Date(props.original.paymentStatus == "SUCCESS" ? props.original.paymentDate : props.original.invoiceDate)
                                                                .toLocaleDateString({ timeZone: "UTC", month: "long", day: "2-digit", year: "numeric" }
                                                                )} - {props.original.paymentStatus == "SUCCESS" ? "Paid" : "Pending"}</div>

                                                        )
                                                    }
                                                ]}
                                                showPagination={false}
                                                style={{ height: "400px", backgroundColor: "#ffffff", padding: '10px' }}
                                                className="-highlight"
                                                pageSize={this.state.invoices.length <= 7 ? 7 : this.state.invoices.length}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-9" id='invoice' style={{ flexBasis: "72%", maxWidth: "72%" }}>
                                        <div className="card">
                                            <div style={{
                                                display: this.state.displayInvoiceItem && !this.state.isViewCreditUsage ? 'block' : 'none'
                                            }}>
                                                {/* <InvoicePage
                                                        projectName={this.state.projectName}
                                                        paymentStatus={this.state.paymentStatus}
                                                        billingSetting={this.state.billingSetting}
                                                        property={this.state.invoiceHtml} /> */}
                                                <iframe
                                                    scrolling='no'
                                                    style={{
                                                        minHeight: '900px',
                                                        width: '100%'
                                                    }}
                                                    onLoad={this.addMakePaymentButton}
                                                    id="invoice_iframe">
                                                </iframe>
                                            </div>
                                            <div style={{ display: this.state.isViewCreditUsage ? 'block' : 'none', minHeight: '550px' }}>
                                                <ViewCreditUsage ref="child" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div >
                    </div>
                    {/****************start of raise ticket and left menu modal***** */}
                    <div class="modal" id="myModal" style={{ display: this.state.showRaiseTicketPage ? 'block' : 'none', paddingTop: "0px" }}>
                        <div class="modal-dialog " id="center-aligned-ticket-modal">
                            <div class="modal-content" id="modal-content-body" style={{ height: "auto", width: "800px", padding: "0px" }}>

                                <div class="modal-body">
                                    <div className="card-body p-0 mb-25">
                                        <div className="tab-content col-12 p-0">
                                            <div className="tab-pane active show" id="tab_1">
                                                <div className="card card-primary mt-3">
                                                    <div class="modal-header noBorder">
                                                        <button type="button" class="close" data-dismiss="modal" onClick={this.closeRaiseTicketPage}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                                <path d="M0 0h24v24H0z" fill="none" />
                                                            </svg>
                                                        </button>

                                                    </div>
                                                    <form role="form" className="raiseTicketLable">

                                                        <div className="card-body raise-form">

                                                            <div className="form-group col-6 pull-left p-0">
                                                                <label className="col-12 pull-left " htmlFor="Subject">Title</label>
                                                                <input type="text" className="form-control col-11 raise-form-input" id="title" placeholder="Subject" />
                                                            </div>
                                                            <div className="form-group col-6 pull-left">
                                                                <label className="col-12 pull-left ">Ticket Type</label>
                                                                <div className="form-group col-md-12 pull-left selectOption p-0 reqTypeSelect">
                                                                    <select id="Ticket-type" className="form-control select2 " style={{ width: '100%' }} tabIndex={-1} aria-hidden="true">

                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="form-group col-12 pull-left p-0">
                                                                <label className="" htmlFor="exampleInputPassword2">Description</label>
                                                                <textarea className="form-control raise-form-input" rows={3} placeholder="Enter Description .." defaultValue={""} id="description" />
                                                            </div>
                                                            <div className="form-group col-6 pull-left">
                                                                <label className="col-12 pull-left " htmlFor="exampleInputPassword1">Ticket Status</label>
                                                                <div className="form-group col-md-12 pull-left selectOption p-0 reqTypeSelect">
                                                                    <select id="Ticket-status" className="form-control select2 " style={{ width: '100%' }} tabIndex={-1} aria-hidden="true">

                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="form-group col-6 pull-left">
                                                                <label className="col-12 pull-left " htmlFor="exampleInputPassword1">Ticket Priority</label>
                                                                <div className="form-group col-md-12 pull-left selectOption p-0 reqTypeSelect">
                                                                    <select id="Ticket-priority" className="form-control select2 " style={{ width: '100%' }} tabIndex={-1} aria-hidden="true">

                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="form-group col-12 pull-left mt-1 p-0">
                                                                <label className="col-12 pull-left " htmlFor="Subject">Attach File</label>
                                                                <div className="custom-file">

                                                                    <input type="file" accept="image/x-png,image/jpeg" id="inputFile1" onChange={this.ticketfileChangedHandler} />
                                                                    <span> *Supports only ./png,./jpg formats </span>
                                                                </div>
                                                            </div>
                                                            <div className="raise-form pull-left pt-3">
                                                                {/* <label className="col-12 pull-left"  /> */}
                                                                <button type="button" style={{ width: "200px" }} className="btn pull-right navyblue-btn" onClick={this.submitApi}>Submit</button>
                                                            </div>
                                                        </div>
                                                        {/* <DialogComponent width='250px' id="update" animationSettings={this.settings} header='Success' showCloseIcon={true} buttons={this.Okbutton} ref={dialog => this.dialogInstance = dialog} visible={this.state.hideTicketGenerateDialog} close={this.dialogClose}><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />Ticket generated successfully</DialogComponent> */}
                                                    </form>
                                                </div>
                                            </div>
                                        </div></div></div></div>

                        </div></div>
                    {/*************previous page */}
                    <div class="modal" id="myModal" style={{ display: this.state.showPreviousTicketPage ? 'block' : 'none' }}>
                        <div class="modal-dialog" id="center-aligned-modal">
                            <div class="modal-content" id="modal-content-body" style={{ height: "auto", width: "1200px", padding: "0px", backgroundColor: "#F9F9FB" }}>


                                {/* <TrialIframe /> */}
                                <div class="modal-header noBorder">
                                    <button type="button" class="close" title="close" data-dismiss="modal" onClick={this.closePreviousTicketPage}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                            <path d="M0 0h24v24H0z" fill="none" />
                                        </svg>
                                    </button>

                                </div>
                                <div class="modal-body">


                                    <div className="row">
                                        <div className="col-sm-6 signinTitle">
                                            <h4 style={{ textAlign: 'right' }}>Ticket History</h4>
                                        </div>
                                        <div className="col-sm-3">
                                            <div Align="right">
                                                <select id="Ticket-status-drop-down" className="form-control select2 " onChange={this.statushandlechange} style={{ width: '50%', marginTop: "12px" }} tabIndex={-1} aria-hidden="true">
                                                    <option value="false">OPEN</option>
                                                    <option value="true">CLOSED</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">



                                            <div Align="right">

                                                <button type="button" className="btn navyblue-btn" onClick={this.showRaiseTicket}>
                                                    <span className="delereuserbtn" >RaiseTicket</span></button>
                                            </div>
                                        </div>
                                    </div>


                                    <form>

                                        <div className="content">
                                            <div className="container-fluid">

                                                <div className="row">
                                                    <div className="col-lg-3 ">
                                                        <div className="card">
                                                            <div>
                                                                <ReactTable id='reactTable'
                                                                    data={this.state.ticketData}
                                                                    columns={[
                                                                        {
                                                                            Header: <b>Tickets</b>,
                                                                            accessor: 'title',
                                                                            overflow: "visible",
                                                                            sortable: false,
                                                                            Cell: props => (

                                                                                <div Align="left" className="cursor-change" onClick={(e) => {
                                                                                    (props.original.id == this.state.editedId || (props.original.title.trim() == "") || props.original.description.trim() == "") ? this.saveTicketCell(props, e)
                                                                                        :
                                                                                        this.editTicketCell(props, e);

                                                                                }} contentEditable={false}>
                                                                                    <div class="listContent userIdBox">
                                                                                        <div style={{ marginTop: "15px" }}
                                                                                            contentEditable={false}


                                                                                            suppressContentEditableWarning
                                                                                            type="text" id={"ticketTictle" + props.index}

                                                                                        > <b>{props.original.title === '' ? 'No Tickets Found' : props.original.title}</b></div></div>
                                                                                    <div class="listContent userIdBox">
                                                                                        <div style={{ marginTop: "15px" }}
                                                                                            contentEditable={false}


                                                                                            suppressContentEditableWarning
                                                                                            type="text" id={"ticketTictle" + props.index}

                                                                                        >{props.original.ticketType}</div>
                                                                                        <div style={{ marginTop: "15px", Align: "right", color: (props.original.ticketPriority === "CRITICAL") ? "red" : "orange" }}
                                                                                            contentEditable={false}


                                                                                            suppressContentEditableWarning
                                                                                            type="text" id={"ticketTictle" + props.index}

                                                                                        >{props.original.ticketPriority}</div>
                                                                                    </div></div>

                                                                            )
                                                                        }



                                                                    ]}
                                                                    showPagination={false}
                                                                    style={{ height: "400px" }}
                                                                    className="-highlight"
                                                                    defaultPageSize={this.state.ticketData.length}
                                                                    pageSize={this.state.ticketData.length}


                                                                />
                                                            </div>
                                                        </div></div>
                                                    <div className="col-lg-9" style={{ height: "400px", overflowY: "scroll" }}>
                                                        <div className="card-body raise-form" style={{ backgroundColor: "#eff4f9" }}>




                                                            <div className="form-group col-6 pull-left p-0">

                                                                <h2 className={this.state.ticketTitle == '' ? '' : "signinTitle cursor-change"} title="Click here to close or reopen ticket" onClick={this.showStatusClosePopup} style={{ textAlign: "left" }}>{this.state.ticketTitle === '' ? '' : this.state.ticketTitle}</h2>
                                                                <h6>{this.state.ticketType}</h6><br />
                                                                <h8>{this.state.ticketFileName}</h8>
                                                                <DialogComponent width='400px' animationSettings={this.settings} header='Project' showCloseIcon={true} buttons={this.ticketStatusButton} ref={dialog => this.dialogInstance = dialog} visible={this.state.showTicketStatusPopup} close={this.dialogClose}><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;Do you want to close the ticket?
                                                                    Note: Press 'Yes' to &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Close or press 'No' to decline</DialogComponent>

                                                                <DialogComponent width='400px' animationSettings={this.settings} header='Project' showCloseIcon={true} buttons={this.ticketStatusButton} ref={dialog => this.dialogInstance = dialog} visible={this.state.showTicketStatusOpenPopup} close={this.dialogClose}><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;Do you want to reopen the ticket?
                                                                    Note: Press 'Yes' to &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; reopen or press 'No' to decline</DialogComponent>

                                                            </div>
                                                            <div className="form-group col-6 pull-left" Align="Right">
                                                                <h4 style={{ color: (this.state.ticketStatus === "OPEN") ? "green" : "red", marginTop: "1.5rem" }}>{this.state.ticketType === '' ? '' : this.state.ticketStatus + '|'}</h4><h8>{this.state.lastModifiedDate}</h8>
                                                                <br /><br />
                                                                <h8 style={{ color: (this.state.ticketPriority === "CRITICAL") ? "red" : "orange" }}>{this.state.ticketPriority}</h8>

                                                            </div>
                                                        </div>
                                                        <br />
                                                        <div id="reactTable" className="table mangeClientTable text-center">


                                                            <ReactTable id='reactTable'
                                                                data={this.state.ticketInfo}
                                                                columns={[
                                                                    {
                                                                        Header: <b>Comments</b>,
                                                                        accessor: 'comment',
                                                                        minWidth: 17,
                                                                        overflow: "visible",
                                                                        sortable: false,
                                                                        Cell: props => (<div class="direct-chat-msg " Align="left" >
                                                                            <div class="direct-chat-text chat_left" style={{ marginTop: "20px", backgroundColor: "#fbf7f7" }} var date={new Date(props.original.commentTime)}>
                                                                                <b>{props.original.comment}</b>
                                                                                <br />

                                                                                {props.original.commentType === '' ? "" : props.original.commentType + ' ' + '|' + ' ' + props.original.commentTime}
                                                                            </div>
                                                                        </div>)
                                                                    }]}
                                                                showPagination={false}
                                                                style={{ height: (this.state.ticketInfo.length > 1) ? "280px" : "170px" }}
                                                                defaultPageSize={this.state.ticketInfo.length}
                                                                pageSize={this.state.ticketInfo.length}
                                                            />

                                                        </div>
                                                        <br />
                                                        <div className="form-group col-12 pull-left p-0">
                                                            <label className="" htmlFor="exampleInputPassword2" textColor="#007aff">Post your Comments</label>
                                                            <div className="row">
                                                                <div className="col-sm-10">
                                                                    <textarea className="form-control raise-form-input" rows={3} placeholder="Post something here .." id="comment" style={{ width: "765px", position: "relative" }}></textarea>
                                                                    &nbsp;</div>
                                                                <div className="col-sm-2">
                                                                    <div align="right">
                                                                        <button type="button" title="Submit" onClick={this.saveTicketCommentsApi} style={{ width: "74px", height: "74px", position: "relative" }}><img src="assets/images/submitArrow.svg" ></img></button>
                                                                    </div> </div>
                                                            </div>

                                                            <div className="raise-form pull-left pt-3">

                                                            </div>
                                                        </div></div>
                                                </div></div>

                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>

                    {/*-----------------------------------My Account Page Popup------------------------*/}

                    <div className="modal" style={{ display: this.state.showMyAcountPopUp ? 'block' : 'none' }}>
                        <div className="modal-dialog" id="center-aligned-account-modal">
                            <div className="modal-content" style={{ height: "600px", width: "900px" }}>
                                <div className="modal-header noBorder">
                                    <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={this.closeMyAccountPage}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                            <path d="M0 0h24v24H0z" fill="none" />
                                        </svg>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form ref={(el) => this.myFormRef = el}>
                                        <MyAccount />
                                    </form>
                                </div>
                            </div>
                        </div>
                        <DialogComponent width='200px' style={{ position: "fixed" }} animationSettings={this.settings}
                            header='Log out?' showCloseIcon={true} buttons={this.logoutButton}
                            ref={dialog => this.dialogInstance = dialog}
                            visible={this.state.hideLogoutConfirmation} close={this.dialogClose}>
                            <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                content="" />&nbsp;Are you sure you want to log out?</DialogComponent>
                    </div>
                </div>
            </div>
        );
    }
}
export default Invoices;


// WEBPACK FOOTER //
// ./src/projectmgmt/header/Invoices.js